// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"styles_pageTitle__22Cg3","title":"styles_title__3wRmf","subtitle":"styles_subtitle__2VVCl"};